import { getStatisticsFields } from '@/data/generators/statisticsFieldsData';
import { filterByGameLocationsAndResults } from '@/utils/playsFiltering';
import { getTeamTableData } from '@/utils/teamTableData';
import { getDonutPassesData } from '@/data/generators/passesDonutData';
import { commonValues } from '@/data/statisticsFieldsValues';
import teamStatsPlayIndexes from '@/data/team/teamStatsPlayIndexes';
import { possession } from '@/data/team/featured-players-categories';

const state = {
  indexes: teamStatsPlayIndexes(),
  basePlaysStack: [],
  featuredPlayersCategories: possession,
};

const mutations = {
  updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
};

const getters = {
  getPlaysStack(state, getters, rootState, rootGetters) {
    const sections = rootGetters['filterGeneral/getSections'];
    return getters.filteredPlaysStack.filter(play => sections.includes(play[state.indexes.section]));
  },
  filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      teamStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  fieldStatisticsData(state, getters, rootState, rootGetters) {
    return getStatisticsFields(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      commonValues,
      teamStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  tableData(state, getters, rootState, rootGetters) {
    //Statistic_id helps to select if data current average is divided by games played or season teams
    const STATISTIC_ID = rootGetters['filterGeneral/getStadisticId'];
    const totalSeasonGamesOrTeams =
      STATISTIC_ID === 0
        ? rootGetters['gamesGeneral/gamesPlayed']
        : rootGetters['teamsGeneral/teamsForAnalysis'].length;
    return getTeamTableData(
      1,
      getters.filteredPlaysStack,
      rootGetters['leagueGeneral/filteredPlaysStack'],
      rootGetters['filterGeneral/getSections'],
      totalSeasonGamesOrTeams,
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  passesDonutData(state, getters, rootState, rootGetters) {
    return getDonutPassesData(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      rootGetters['teamsGeneral/team'].team_id,
      teamStatsPlayIndexes(),
    );
  },
  topFiveCategories() {
    return [
      {
        name: 'participación en goles',
        rank: 1,
        total: 44,
        max: 'owner',
      },
      {
        name: 'cabeceo área rival',
        rank: 2,
        total: 13,
        max: 20,
      },
      {
        name: 'tiros a gol',
        rank: 3,
        total: 20,
        max: 26,
      },
      {
        name: '1 vs 1 ofensivo exitoso',
        rank: 4,
        total: 22,
        max: 32,
      },
      {
        name: 'asistencias',
        rank: 4,
        total: 2,
        max: 4,
      },
    ];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
